// Hash of /public/cost_data/*.json so a snapshot diff caused by data updates
// is distinguishable from one caused by code/formula changes. Concatenates
// files in sorted-name order, SHA-256, first 12 hex characters.
//
// Mirrors the logic embedded in [cost-editor].screen.tsx — extracted here
// so admin tooling (cost-tracking screen) can surface the same hash and
// force a fresh fetch via cache: "no-store".
const COST_DATA_FILES = [
  "kit_base_build_element_reference.json",
  "kit_module.json",
  "kit_module_bill_of_material.json",
  "kit_module_element_reference.json",
  "kit_unit.json",
  "kit_unit_module.json",
];

export async function GetCostDataHash(): Promise<string> {
  const bodies = await Promise.all(
    COST_DATA_FILES.map(async (f) => {
      const r = await fetch(`/cost_data/${f}`, { cache: "no-store" });
      return await r.text();
    })
  );
  const buf = new TextEncoder().encode(bodies.join("\n"));
  const digest = await crypto.subtle.digest("SHA-256", buf);
  return Array.from(new Uint8Array(digest))
    .map((b) => b.toString(16).padStart(2, "0"))
    .join("")
    .slice(0, 12);
}
